import { useEffect, useState } from 'react'
import { string, arrayOf, object } from 'prop-types'
import Modal from '@ui/component/Modal'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const DeleteButton = ({ message = '', buttons = [], label = '' }) => {
  const [isModalActive, setModal] = useState(false)
  const toggleModal = () => {
    setModal(!isModalActive)
  }

  buttons = buttons.map(button => {
    if (typeof button.callback === 'undefined') {
      return {
        ...button,
        callback: toggleModal
      }
    }
    return button
  })

  useEffect(() => {

  }, [isModalActive])

  return (
    <Div cssClass='delete-button-zone'>
      <Buttons buttons={{ icon: 'icon-bin', cssClass: 'toggle-delete is-small is-danger', callback: toggleModal, text: label }} />
      <Modal cssClass='delete-modal' isActive={isModalActive} closeCallback={toggleModal}>
        <Div cssClass='confirm-action'>
          <h3>{message}</h3>
          <Div cssClass='confirmation-zone'>
            <Buttons buttons={buttons} />
          </Div>
        </Div>
      </Modal>
    </Div>
  )
}

DeleteButton.propTypes = {
  buttons: arrayOf(object),
  message: string,
  label: string
}

export default DeleteButton
